// extracted by mini-css-extract-plugin
module.exports = {"feed":"ChannelHome_feed__JrTdn","sidebarright":"ChannelHome_sidebarright__4NtMX","sidebarleft":"ChannelHome_sidebarleft__nlT8J","inner":"ChannelHome_inner__icHff"};